import { motion } from 'framer-motion';
import { ArrowUpRight, MessageCircle, Phone } from 'lucide-react';
import { CONTACT } from '../data/site';

const CARDS = [
  {
    label: 'WhatsApp',
    value: CONTACT.whatsappDisplay,
    hint: 'Resposta rápida no seu app favorito',
    url: CONTACT.whatsappUrl,
    icon: MessageCircle,
    testid: 'contato-whatsapp-btn',
    accent: 'text-[#25D366]',
    hover: 'hover:border-[#25D366]/60 hover:shadow-[0_0_30px_rgba(37,211,102,0.2)]',
  },
  {
    label: 'Telefone',
    value: CONTACT.phoneDisplay,
    hint: 'Ligação direta para a cozinha',
    url: CONTACT.phoneUrl,
    icon: Phone,
    testid: 'contato-phone-btn',
    accent: 'text-[#FF5500]',
    hover: 'hover:border-[#FF5500]/60 hover:shadow-[0_0_30px_rgba(255,85,0,0.2)]',
  },
];

export default function Contact() {
  return (
    <section id="contato" className="bg-[#101013] py-24 sm:py-32" data-testid="contato-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="font-mono-alt text-xs font-semibold uppercase tracking-[0.3em] text-[#FFB800]"
        >
          Contato
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-4 font-display text-5xl uppercase leading-none text-white sm:text-6xl"
        >
          Fale com a gente
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="font-serif-accent mt-4 text-xl text-zinc-400"
        >
          Sem formulários chatos. Atendimento direto, do jeito que você preferir.
        </motion.p>

        <div className="mt-12 grid max-w-4xl gap-6 sm:grid-cols-2">
          {CARDS.map((card, i) => (
            <motion.a
              key={card.label}
              href={card.url}
              target={card.url.startsWith('http') ? '_blank' : undefined}
              rel={card.url.startsWith('http') ? 'noreferrer' : undefined}
              data-testid={card.testid}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              whileHover={{ y: -6 }}
              className={`group rounded-3xl border border-white/10 bg-[#141418] p-8 transition-all duration-300 ${card.hover}`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`grid h-12 w-12 place-items-center rounded-2xl border border-white/10 bg-white/5 ${card.accent}`}
                >
                  <card.icon size={22} />
                </span>
                <ArrowUpRight
                  size={20}
                  className="text-zinc-600 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-white"
                />
              </div>
              <p className="mt-6 text-xs font-bold uppercase tracking-[0.25em] text-zinc-400">
                {card.label}
              </p>
              <p className="mt-1 break-all text-lg font-bold text-white">{card.value}</p>
              <p className="mt-2 text-sm text-zinc-500">{card.hint}</p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
